export const environment = {
  production: false,
  api: 'https://api-dev.agrotransparencia.com.br',
  frontUrl: 'https://masterboi.qualidadepereciveis.com.br',
  supportApi: 'https://api-dev.agrotransparencia.com.br',
  // MOCK: dashboards read production data so the client can validate it in dev. Set back to `api` to undo.
  dashboardApi: 'https://api-masterboi.qualidadepereciveis.com.br',
  XAPIKEY: '8f3c9a12-4d7e-45b1-8a5d-2a7e6d9f21ab',
  JSESSIONID: 'F46186D349D19ECF5F26083E1E342A02'
};